exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "modal-delegation-manager .modal .modal-dialog{max-height:410px;max-width:520px}modal-delegation-manager .modal.mobile .modal-dialog{max-height:none;max-width:none}modal-delegation-manager .modal.mobile .modal-dialog .modal-content{padding:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/modalDelegationManager/modalDelegationManager.scss
// module id = 911
// module chunks = 0